/* global require, Promise*/
import React, { Component } from 'react';
import Ask from './src/components/Ask.js';
import { Platform } from 'react-native';
import { AppLoading } from 'expo';
import * as Font from 'expo-font';
import { Ionicons } from '@expo/vector-icons';
import { C, styles } from './src/constants';

import { Container, Root, Drawer } from 'native-base';
import { Provider } from 'react-redux';
import AppHeader from './src/components/AppHeader';
import AppFooter from './src/components/AppFooter';
import AppCover from './src/components/AppCover';
import AppLoader from './src/components/AppLoader';
import { Dimensions, View } from 'react-native';

import configureStore from './src/store/configureStore';
import Dialog from './src/components/Dialog';
import AppScrollView from './src/components/AppScrollView';
import SideMenu from "./src/components/SideMenu.js";
let deviceWidth = Dimensions.get('window').width;

const store = configureStore();

function cacheFonts(fonts) {
  return fonts.map(font => Font.loadAsync(font));
}

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isReady: false,
      loaded: false
    };
  }

  componentDidMount() {
  }

  async _loadAssetsAsync(self) {
    let fontAssets;

    if (C.PRODUCT === "RZD" || C.PRODUCT === "RZD_EMPL") {

      fontAssets = cacheFonts([
        { Roboto: require('./assets/fonts/ProximaNova-Regular.ttf') },
        { Roboto_medium: require('./assets/fonts/ProximaNova-Semibold.ttf') },
        Ionicons.font
      ]);

    } else {

      fontAssets = cacheFonts([
        { Roboto: require('./assets/fonts/Roboto.ttf') },
        { Roboto_medium: require('./assets/fonts/Roboto_medium.ttf') },
        Ionicons.font
      ]);

    }

    const timer = setTimeout(() => {
      if (Platform.OS === 'web') {
        const brokenActionSheetOnWeb = document.querySelector('#root div + div[style*="border-color: rgb(255, 0, 0);"]');

        if (brokenActionSheetOnWeb) {
          brokenActionSheetOnWeb.style.display = 'none';
        }
      }
      self.setState({ loaded: true });
    }, C.COVER_TIMEOUT);

    await Promise.all([timer, ...fontAssets]);
  }
  closeDrawer = () => {
    this.drawer._root.close();
  };

  openDrawer = () => { this.drawer._root.open(); };

  AppContent = () => <Root>
    {Platform.OS === 'web' && <AppHeader drawer={this.drawer} />}
    <Ask  />
    <AppFooter />
  </Root>;

  render() {
    if (!this.state.isReady) {
      return <>
        <AppLoading
          startAsync={this._loadAssetsAsync.bind(null, this)}
          onFinish={() => this.setState({ isReady: true })}
          onError={console.warn}
        />
      </>;
    }
    // console.log("this.drawer: ", this.drawer);
    return <Provider store={store}>
      <>

          {Platform.OS === 'web' ? <AppLoader /> : null}
          {!this.state.loaded && Platform.OS === 'web' ? <AppCover /> : null}
          {Platform.OS !== 'web' && this.state.loaded ? <AppHeader /> : null}
          <Container>
            <Drawer
                ref={(ref) => { this.drawer = ref; }}
                content={<SideMenu navigator={this.navigator} />}
                // content={<SideMenu navigator={this.navigator} />}
                onClose={() => this.closeDrawer()}
                panOpenMask={0.25}
            >
            {!this.state.loaded && Platform.OS !== 'web' ? <AppCover /> : null}
            {Platform.OS !== 'web' ? <AppLoader /> : null}
            <AppScrollView>
              {deviceWidth <= C.MIN_WIDTH ?
                  this.AppContent()
                  :
                  <View style={styles.appContainer}>
                    <View style={styles.appCol_2}>
                      {this.AppContent()}
                    </View>
                  </View>
              }
            </AppScrollView>
            </Drawer>
          </Container>
          <Dialog />


      </>
    </Provider>;
  }
}
